var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "m16.282 15.218-2.782-2.76a6.75 6.75 0 1 0-1.042 1.042l2.76 2.76a.751.751 0 0 0 1.064 0 .75.75 0 0 0 0-1.042ZM8.25 13.5A5.25 5.25 0 1 1 8.25 3a5.25 5.25 0 0 1 0 10.501Z"
  })));
};
export default SvgSearch;